import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import simpleLoading from 'simple-loading';

Component('tr-repository-upload-new-version', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },
  },

  connected() {
    this.initUploader();
    this.bindUploader();
  },

  initUploader() {
    const $button = $(this).find('.js-uploader-button');
    this.uploader = window.simple.uploader({
      url: this.url,
      params: {
        conn_guid: document.querySelector('#conn-guid').value,
        authenticity_token: document.querySelector('meta[name=csrf-token]').content,
      },
    });

    window.tower.connectUploader($button, this.uploader, {
      title: '上传文件',
      multiple: true,
    });
  },

  bindUploader() {
    this.uploader.on('beforeupload', (e, file) => {
      if (!window.tower.checkUploadFileSize(file)) {
        return false;
      }
      simpleLoading({
        type: 'tiny',
        msg: '正在上传文件',
      });
      return true;
    });

    this.uploader.on('uploadsuccess', (e, file, result) => {
      simpleLoading.destroy();
      window.tower.stack.load(result.url, {
        nocache: true,
        replace: true,
        root: true,
        fluid: true,
      });
    });

    this.uploader.on('uploaderror', (e, file, xhr) => {
      const fileEl = this.container.querySelector(
        `.table-row-uploading[data-file-id="${file.id}"]`,
      );
      fileEl.remove();
      if (xhr.statusText === 'abort') return;
      window.tower.uploaderror(xhr);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
